import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Vue_Router = new Router({
  mode: "history",
  routes: [
    {
      path: "/Error/400",
      component: () => import("../view/Error400")
    },
    {
      path: "/Error/401",
      component: () => import("../view/Error401")
    },
    {
      path: "/Error/404",
      component: () => import("../view/Error404")
    },
    {
      path: "/Error/500",
      component: () => import("../view/Error500")
    },
    {
      path: "/Error/Server404",
      component: () => import("../view/Server404")
    },
    {
      path: "/Error/ServerBan",
      component: () => import("../view/ServerBan")
    },
    {
      path: "/",
      component: () => import("../app/server/List")
    },
    {
      path: "/Rank",
      component: () => import("../app/Rank")
    },
    {
      path: "/Statistics",
      component: () => import("../app/Statistics")
    },
    {
      path: "/Server/Add",
      component: () => import("../app/server/Add")
    },
    {
      path: "/Server/Edit/:id",
      component: () => import("../app/server/Edit")
    },
    {
      path: "/Server/Info/:id",
      component: () => import("../app/server/Info")
    },
    {
      path: "/User/Login",
      component: () => import("../app/user/Login")
    },
    {
      path: "/User/LoginOut",
      component: () => import("../app/user/LoginOut")
    },
    {
      path: "/User/Register",
      component: () => import("../app/user/Register")
    },
    {
      path: "/User/ResetPassword",
      component: () => import("../app/user/ResetPassword")
    },
    {
      path: "/User/Info",
      component: () => import("../app/user/Info")
    },
    {
      path: "/Admin/Index",
      component: () => import("../app/admin/Index")
    },
    {
      path: "/Admin/WebSetting",
      component: () => import("../app/admin/WebSetting")
    },
    {
      path: "/Admin/Server",
      component: () => import("../app/admin/Server")
    },
    {
      path: "/Admin/Tag",
      component: () => import("../app/admin/Tag")
    },
    {
      path: "/Admin/User",
      component: () => import("../app/admin/User")
    },
    {
      path: "/Admin/Advertise",
      component: () => import("../app/admin/Advertise")
    }
  ]
})

export default Vue_Router